import React, { useState } from 'react';
import * as Yup from 'yup';
import { FormProvider, useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import LoadingButton from '@mui/lab/LoadingButton';
import FormControl from '@mui/material/FormControl';

import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useRouter } from '../../../hooks/use-router';
import HttpService from '../../../hooks/Https-services';
import PAGE_ROUTES, { API_ROUTES, ROLE_IDS } from '../../../utils/constant';
import { Grid, TextField } from '@mui/material';
import { RHFTextField } from '../../../components/hook-form';
import { toast } from 'react-toastify';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';
import { ErrorMessage, Field, Form, Formik } from 'formik';

export default function AddShift() {
  const router = useRouter();

  const validationSchema = Yup.object().shape({
    shiftName: Yup.string().required('Shift name is required'),
    roleId: Yup.number().required('Role is required'),
    teamId: Yup.number().required('Team is required'),
  });

  const [teams, setTeams] = useState([]);

  const fetchTeamsList = React.useCallback(async () => {
    try {
      const response = await HttpService.get(API_ROUTES.fatchAllTeam);
      setTeams(response.data.data);
    } catch (error) {
      console.error('Error fetching games list:', error);
    }
  }, []);
  React.useEffect(() => {
    fetchTeamsList();
  }, [fetchTeamsList]);

  const [feld, setFild] = useState<any>({
    shiftName: '',
    roleId: '',
    teamId: '',
    startTime: null,
    endTime: null,
  });

  const handleSubmit = async (values: any, { setSubmitting }: any) => {
    const info = {
      shiftName: values.shiftName,
      roleId: values.roleId,
      teamId: values.teamId,
      startTime: values.startTime
        ? dayjs(values.startTime).toISOString()
        : dayjs().startOf('day').toISOString(),
      endTime: values.endTime
        ? dayjs(values.endTime).toISOString()
        : dayjs().startOf('day').toISOString(),
    };

    try {
      await HttpService.post(API_ROUTES.addShift, info);
      toast.success('Shift Added Successfully', {
        position: 'bottom-right',
      });
      router.push(PAGE_ROUTES.SHIFTS);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box sx={{ margin: 2 }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Formik
          initialValues={feld}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            isSubmitting,
            setFieldValue,
          }) => (
            <Form>
              <Card sx={{ p: 3 }}>
                <Box
                  rowGap={3}
                  columnGap={2}
                  display="grid"
                  gridTemplateColumns={{
                    xs: 'repeat(1, 1fr)',
                    sm: 'repeat(2, 1fr)',
                  }}
                  sx={{ marginTop: '10px' }}
                >
                  <Field
                    name="shiftName"
                    as={TextField}
                    label="Shift Name"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    helperText={
                      touched.shiftName && errors.shiftName
                        ? errors.shiftName
                        : null
                    }
                    error={touched.shiftName && !!errors.shiftName}
                  />

                  <FormControl fullWidth margin="normal">
                    <InputLabel id="role-select-label">Role</InputLabel>
                    <Field
                      name="roleId"
                      as={Select}
                      labelId="role-select-label"
                      label="Role"
                      helperText={
                        touched.roleId && errors.roleId ? errors.roleId : null
                      }
                      error={touched.roleId && !!errors.roleId}
                    >
                      {Object.entries(ROLE_IDS).map(([key, id]) => (
                        <MenuItem key={id} value={id}>
                          {key.toLowerCase()}
                          {/* You can display the role name here */}
                        </MenuItem>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="roleId"
                      component="div"
                      // style={{ color: 'red' }}
                    />
                  </FormControl>

                  <FormControl fullWidth margin="normal">
                    <InputLabel id="team-select-label">Teams</InputLabel>
                    <Field
                      name="teamId"
                      as={Select}
                      labelId="team-select-label"
                      label="Teams"
                      helperText={
                        touched.teamId && errors.teamId ? errors.teamId : null
                      }
                      error={touched.teamId && !!errors.teamId}
                    >
                      {teams.map((team: any) => (
                        <MenuItem key={team.id} value={team.id}>
                          {team.userTeamKey}
                        </MenuItem>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="teamId"
                      component="div"
                      // style={{ color: 'red' }}
                    />
                  </FormControl>
                  <FormControl fullWidth margin="normal">
                    {' '}
                    <TimePicker
                      label="Shift Start Time"
                      value={values.startTime}
                      onChange={(newValue) =>
                        setFieldValue(`startTime`, newValue)
                      }
                      ampm={false}
                      sx={{ width: '100%' }}
                    />
                  </FormControl>

                  <FormControl fullWidth margin="normal">
                    {' '}
                    <TimePicker
                      label="Shift End Time"
                      value={values.endTime}
                      onChange={(newValue) =>
                        setFieldValue(`endTime`, newValue)
                      }
                      ampm={false}
                      sx={{ width: '100%' }}
                    />
                  </FormControl>
                </Box>
                <Stack alignItems="flex-end" sx={{ mt: 3 }}>
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    loading={isSubmitting}
                    disabled={
                      isSubmitting ||
                      !values.shiftName ||
                      !values.roleId ||
                      !values.teamId ||
                      !values.endTime ||
                      !values.startTime
                    }
                  >
                    Create Shift
                  </LoadingButton>
                </Stack>
              </Card>
            </Form>
          )}
        </Formik>
      </LocalizationProvider>
    </Box>
  );
}
